/**
 * 订阅消息模板管理模块路由
 * 对应菜单：订阅消息模板管理
 */

export default [
  // 订阅消息模板列表
  {
    path: 'admin/subscribe/template',
    name: 'TemplateList',
    component: () =>
      import(/* webpackChunkName: "subscribe-template-list" */ '@/views/subscribe/TemplateListView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'subscribe-template-list',
      title: '订阅消息模板管理'
    }
  },
  // 订阅消息模板添加/编辑
  {
    path: 'admin/subscribe/template/edit',
    name: 'TemplateEdit',
    component: () =>
      import(/* webpackChunkName: "subscribe-template-edit" */ '@/views/subscribe/TemplateEditView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'subscribe-template-edit',
      title: '添加/编辑订阅消息模板',
      hidden: true
    }
  }
]
